module.exports = __webpack_public_path__ + "static/media/seaplaneport_marker_light_blue.af0f7bc4.svg";